<template>
    <div class="notification-bell" @click="toggleNotifications">
         <el-tooltip class="box-item" effect="dark" content="Publicaciones" placement="bottom-end">
            <font-awesome-icon v-if="efecto_bounce" class="has-text-light" :icon="['fas', 'bullhorn']" bounce @click="viewPublications()" style="font-size: 22px;" />
            <font-awesome-icon v-else class="has-text-light" :icon="['fas', 'bullhorn']" @click="viewPublications()" style="font-size: 22px;" />
        </el-tooltip>

        <el-drawer v-model="drawer_publications" class="drawer-publications">
            <template #header>
            <el-row>
                <el-col :span="8">
                    <img :src="sucursal_sponsored.sponsor.url_logo" class="drawer-logo-sponsor">
                </el-col>
                <el-col :span="12" style="justify-content: center;display: flex;">
                    <div class="drawer-name-sponsor" :style="{color:brand.color_contraste}">{{ sucursal_sponsored.sponsor.brand }}</div>
                </el-col>
            </el-row>
            </template>
            <template #default>
                <el-row v-loading="loading_full">
                    <el-col v-if="publications.length > 0">
                        <el-row v-for="publication,key in publications" v-bind:key="key" :gutter="24" class="mb-1">
                            <el-col  :span="24" style="text-align: center;">
                                <div class="card-publication" @click="openPublication(publication)">
                                    <el-row>
                                        <el-col style="display: grid;" :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                                            <img :src="publication.image_path" style="width: 90%;">
                                        </el-col>
                                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                                            <div class="card-publication-title" style="text-align: justify!important;">
                                            <b>{{ publication.title.length > 20 ? publication.title.substring(0, 20) + '...' : publication.title }}</b>
                                            </div>
                                            <div class="card-publication-description">
                                                {{ publication.description.length > 100 ? publication.description.substring(0, 100) + '...' : publication.description }}
                                            </div>
                                        </el-col>
                                    </el-row> 
                                </div>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col v-else style="text-align: center;">
                        <div class="card-publication" style="width: 100%; height: 100px; display: grid; align-items: center;">
                            <div class="card-publication-title">
                                No hay publicaciones disponibles
                            </div>
                        </div>
                    </el-col>
                </el-row>
                  
            </template>
        </el-drawer>

    </div>
    <el-dialog
        v-model="modal_publication"
        class="modal-lg modal-preview-advertising d-grid"
        :show-close="false"
    >
        <el-row :gutter="24">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="is-flex is-justify-content-center">
                <el-card style="max-width: 80rem" v-loading="loading_modal">
                    <el-row>
                        <el-col :span="24" style="text-align: end;">
                            <font-awesome-icon :icon="['fas', 'xmark']" @click="modal_publication=false" />
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :xs="24" :sm="24" :md="12" :lg="14">
                            <img :src="single_publication.image_path" alt="">
                        </el-col>

                        <el-col :xs="24" :sm="24" :md="12" :lg="10">
                            <el-row class="mb-3">
                                <el-col>
                                    <div class="publication-title">
                                        {{ single_publication.title }}
                                    </div>
                                </el-col>
                            </el-row>
                            <br>
                            <el-row class="mb-3">
                                <el-col>
                                    <div class="publication-description card-publication-description">
                                        {{ single_publication.description }}
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :sm="24" :md="12" :lg="12" :xl="12">
                                    <div class="publication-available">
                                        Disponibilidad
                                    </div>
                                    
                                </el-col>
                                <el-col :sm="24" :md="12" :lg="12" :xl="12" style=" text-align: end;">
                                    <div>
                                        <el-tag class="ml-2 publication-count-stock" type="primary" effect="plain" round > {{ single_publication.stock_units }} unidades </el-tag>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :sm="24" :md="24" :lg="24" :xl="24">
                                    <div class="publication-date">
                                        Fecha de inicio: {{ filterCreateAt(single_publication.createdAt) }}
                                    </div>
                                    
                                </el-col>
                            </el-row>
                            <br>
                            <el-row class="mt-3">
                                <el-col style="text-align: center;">
                                    <el-button class="publication-btn-solicitar" type="primary" size="large"  style="width:100%"  @click="requestPublication()"> 
                                        SOLICITAR
                                    </el-button>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
        
    </el-dialog>
</template>
<script>

import apiClient from '@/api/apiClient';
import { ElNotification } from 'element-plus'
import { useUserStore } from '@/stores/user';
import { showNotification } from '@/utils/notification';
import Swal from 'sweetalert2';
import moment from 'moment';
import { useVeterinariaStore } from '@/stores/veterinaria';
import { effectScope } from 'vue';




export default {
    name: "drawer-publications",
    components: {
    
    },
    data() {
        return {
            toggleNotifications: false,
            drawer_publications: false,
            modal_publication: false,
            loading_full: false,
            sucursal_sponsored: useUserStore().getSponsored(),
            publications: [],
            single_publication: {},
            loading_modal: false,
            sucursal_id: useVeterinariaStore().getMainVeterinaria().id,
            brand: {
                color: "#0678B7", // Color de la marca inicial
                color_contraste: '#0678B7', // Color de contraste inicial
            },
            efecto_bounce: false
        }
    },
    mounted() {
        this.getSucursalSponsored();
        this.getPublications();
        this.calculateContrastColor(this.sucursal_sponsored.sponsor.brand_color);
    },

    created() {
        
    },
    methods: {

        viewPublications(){
            this.drawer_publications = true;
            this.publications = [];
            this.single_publication = {};
            this.getPublications();
        },

        openPublication(_publication) {
            this.single_publication = this.publications.find((publication) => publication.id === _publication.id);
            this.addViews(this.single_publication.id);
            this.modal_publication=true;
        },

        getPublications(){
            this.loading_full = true;
            apiClient.get('/sponsor-publication/get-publications/'+this.sucursal_sponsored.sponsor.id)
                .then((response) => {
                    this.efecto_bounce = false;
                    this.publications = response.data.data;
                    if(this.publications.length > 0){
                        // Validar que por lo menos una publicación sea status='activa'
                        let exists_active = this.publications.some(pub => pub.status === 'activa');
                        if(exists_active){
                            this.efecto_bounce = true;
                        }

                    }
                    this.loading_full = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.loading_full = false;
                });
        },

        async requestPublication() { 
            this.loading_modal = true;

            await apiClient.post('/sponsor-publication/request-publication', {
                    publication_id: this.single_publication.id,
                })
                .then((response) => {
                    showNotification('Éxito', 'Solicitud enviada con éxito.', 'success');
                    this.modal_publication = false;
                    this.loading_modal = false;
                })
                .catch((error) => {
                    console.log(error);
                    showNotification('Error', error.response.data.msg , 'error');
                    this.loading_modal = false;
                    return;
                    
                });
        },

        async addViews(_publication_id) {
            await apiClient.post('/sponsor-publication/add-view', {
                publication_id: _publication_id,
                sucursal_id: this.sucursal_id,
                sponsor_id: this.sucursal_sponsored.sponsor.id,
            })
            .then((response) => {
                console.log(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
        },

        calculateContrastColor(hexColor) {
            console.log('Calculando color de contraste para:', hexColor);
            //el-drawer__close-btn
            this.$nextTick(() => {
                const header = document.querySelector('.el-drawer__header');
                if (header) {
                    header.style.background = hexColor;
                }
            });

            // Asegurarse de que el formato es correcto
            if (!hexColor || !hexColor.startsWith('#') || hexColor.length !== 7) {
                console.warn('Formato de color hexadecimal inválido:', hexColor);
                return '#0678B7'; // Negro por defecto en caso de error
            }

            try {
                // Convertir hex a RGB
                const r = parseInt(hexColor.slice(1, 3), 16);
                const g = parseInt(hexColor.slice(3, 5), 16);
                const b = parseInt(hexColor.slice(5, 7), 16);
                
                // Calcular luminosidad (fórmula percibida WCAG)
                const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
                
                // Si la luminosidad es mayor a 0.5, usar texto negro, de lo contrario blanco
                console.log(luminance > 0.5 ? '#000000' : '#FFFFFF');
                this.brand.color_contraste = luminance > 0.5 ? '#000000' : '#FFFFFF';
                //asignale el color a esta clase .el-drawer__close-btn
                this.$nextTick(() => {
                    const closeButton = document.querySelector('.el-drawer__close-btn');
                    if (closeButton) {
                        closeButton.style.color = this.brand.color_contraste;
                    }
                });

            } catch (error) {
                console.error('Error al calcular el color de contraste:', error);
                return '#0678B7'; // Negro por defecto en caso de error
            }
        },

        getSucursalSponsored(){
            // Conectarse al endpoint GET sponsorship-licensing/validate-branch-is-sponsored
            apiClient.get('sponsorship-licensing/validate-branch-is-sponsored')
            .then((response) => {
                //Valor asignado es true o false
                console.log('Sucursal patrocinada->:', response.data.data);
                localStorage.setItem('sucursal_sponsored', JSON.stringify(response.data.data));
                this.sucursal_sponsored = response.data.data;
            })
            .catch((error) => {
                console.error('Error al validar la sucursal patrocinada:', error);
            });

        },

        filterCreateAt(_date) {
            return moment(_date).format('DD-MM-YYYY HH:mm');
        }


    },
    computed: {
        
    },
    

    
}
</script>

  
<style>
    .el-drawer__header{
        margin-bottom:5px!important;
    }
    .el-drawer__body{
        padding-top: 0px!important;
    }
    .badge {
        position: absolute;
        top: -1px;
        left: 29px;
        background: red;
        color: white;
        font-size: 12px;
        border-radius: 50%;
        padding: 0px 4px;
        min-width: 10px;
        text-align: center;
    }
    .publication-date{
        font-size: 0.9rem;
        color: #555;
    }
    

</style>  